import React, { useState } from 'react'
import { Panel, Row, Col, Form, SelectPicker } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ProjectInfoView from '../projectBasicInfo/ProjectInfoView'

export default function ManageProjectStatusForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  return (
    <>
      {schema && (
        <Form fluid>
          <div>
            <Row style={{ marginTop: 30 }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <ErrorMessage
                  error={errors[schema.projectStatus.name]}
                  style={{ marginBottom: 10 }}
                />

                {requiredFiled(schema.projectStatus.validators, schema.projectStatus.label)}

                <Controller
                  name={schema.projectStatus.name}
                  control={control}
                  defaultValue={schema.projectStatus.value}
                  rules={isValidators(schema.projectStatus.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={schema.projectStatus.options}
                        searchable={false}
                        disabled={schema.projectStatus.disabled}
                        value={props.value}
                        block
                        placeholder={
                          schema.projectStatus.hint || `เลือก${schema.projectStatus.label}`
                        }
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={schema.note}
                  rows={4}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </>
  )
}
